import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-error" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__action" }

import CommonButton from "@/components/common/CommonButton.vue";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorView',
  setup(__props) {

// import { RefreshCcw04 } from "utruckin-icons";
const router = useRouter();

// const goBack = () => {
//   router.go(-1);
// };

const goHome = () => {
  router.push("/");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main__content" }, "Error", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "main__headline" }, "Something went wrong", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "main__description" }, " An unexpected error occurred. Please try again later or contact support if the problem persists. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommonButton, {
          onClick: goHome,
          type: "primary",
          label: "Go to home"
        })
      ])
    ])
  ]))
}
}

})